var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-steps-pages"},[_c('div',{staticClass:"steps"},[_c('go-steps',{attrs:{"current":_vm.pageIndex,"steps":_vm.steps}})],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/layoutVue/go-steps-pages.vue